import { gsap, Power2, Expo } from 'gsap'
import { ScrollToPlugin }     from 'gsap/ScrollToPlugin'
import Macy                   from 'macy'

gsap.registerPlugin(ScrollToPlugin)

document.querySelectorAll('figure').forEach(el =>
{
	el.addEventListener('contextmenu', e =>
	{
		e.preventDefault()
	})
})

document.querySelector('#footer .scrolltop').addEventListener('click', (e) =>
{
	e.preventDefault()
	
	gsap.to(window, {
		scrollTo: 0,
		duration: .5,
		ease: Power2.easeOut
	})
})

resizeFrontpageSections()
//resizeSectionsPhotoText()

window.addEventListener('resize', () =>
{
	resizeFrontpageSections()
	//resizeSectionsPhotoText()
})

const header = document.querySelector('#header')

if(header){
	const scroll = header.querySelector('.scroll')
	
	if(scroll){
		scroll.addEventListener('click', e =>
		{
			e.preventDefault()
			
			const offset = getOffset(e.currentTarget.parentElement.parentElement.nextElementSibling)
			
			gsap.to(window, {
				scrollTo: offset.y,
				duration: .5,
				ease: Power2.easeOut
			})
		})
	}
}

const frontpageSections = document.querySelectorAll('section[data-frontpage]')

frontpageSections.forEach(el =>
{
	const inner = el.querySelector('.inner')
	const close = el.querySelector('.close')
	let closed = false
	const posX = el.dataset.Align === 'right' ? (490 - 48 - 24) + 'px' : (48 + 24) + 'px'
	const posY = el.dataset.Align === 'right' ? (48 + 24) + 'px' : (48 + 24) + 'px'
	const scroll = el.querySelector('.scroll')
	
	if(scroll){
		scroll.addEventListener('click', e =>
		{
			e.preventDefault()
			
			const offset = getOffset(e.currentTarget.parentElement.parentElement.parentElement.nextElementSibling)
			
			gsap.to(window, {
				scrollTo: offset.y,
				duration: .5,
				ease: Power2.easeOut
			})
		})
	}
	
	close.addEventListener('click', e =>
	{
		e.preventDefault()
		
		gsap.to(inner, {
			scale: closed ? 1 : 0,
			transformOrigin: `${posX} ${posY}`,
			duration: .4,
			ease: Power2.easeOut,
			onStart: () =>
			{
				closed = !closed
			}
		})
	})
})

const photos = document.querySelector('section[data-photos] .photos')

if (photos)
{
	initMasonry()
}

const universSections = document.querySelectorAll('section[data-univers]')

universSections.forEach(el =>
{
	const button = el.querySelector('.button')
	const scroll = el.querySelector('a.scroll')
	
	if (button)
	{
		button.addEventListener('click', e =>
		{
			if (!button.getAttribute('href'))
			{
				e.preventDefault()
				
				const offset = getOffset(e.currentTarget.parentElement.parentElement.nextElementSibling)
				
				gsap.to(window, {
					scrollTo: offset.y - 60,
					duration: .5,
					ease: Power2.easeOut
				})
			}
		})
	}
	
	if (scroll)
	{
		scroll.addEventListener('click', e =>
		{
			e.preventDefault()
			
			const offset = getOffset(e.currentTarget.parentElement.parentElement.nextElementSibling)
			
			gsap.to(window, {
				scrollTo: offset.y - 60,
				duration: .5,
				ease: Power2.easeOut
			})
		})
	}
})

const blogCategories = document.querySelector('section[data-blog_categories]')

if (blogCategories)
{
	const toggleMenu = blogCategories.querySelector('.toggle_menu')
	const toggleSearch = blogCategories.querySelector('.toggle_search')
	const menu = blogCategories.querySelector('ul')
	const search = blogCategories.querySelector('form')
	
	toggleMenu.addEventListener('click', (e) =>
	{
		if (e.target === e.currentTarget)
		{
			menu.classList.toggle('open')
			search.classList.remove('open')
		}
	})
	
	toggleSearch.addEventListener('click', (e) =>
	{
		if (e.target === e.currentTarget)
		{
			search.classList.toggle('open')
			menu.classList.remove('open')
			
			setTimeout(() =>
			{
				search.querySelector('input').focus()
			}, 300)
		}
	})
}

function resizeFrontpageSections ()
{
	const header = document.querySelector('#header')
	
	if (header)
	{
		const img = header.querySelector('img')
		
		gsap.set(header, {
			height: img.naturalHeight * window.innerWidth / img.naturalWidth
		})
	}
	
	const frontpageSections = document.querySelectorAll('section[data-frontpage]')
	
	frontpageSections.forEach(section =>
	{
		const img = section.querySelector('img')
		
		gsap.set(section, {
			height: img.naturalHeight * window.innerWidth / img.naturalWidth
		})
	})
}

function resizeSectionsPhotoText ()
{
	const sections = document.querySelectorAll('section[data-photo_text]')
	
	sections.forEach(section =>
	{
		const container = section.querySelector('.container')
		const img = section.querySelector('img')
		let height = img.naturalHeight * img.clientWidth / img.naturalWidth
		
		gsap.set([section, container], {
			minHeight: height
		})
		
		/*const container = section.querySelector('.container')
		 const figure = section.querySelector('figure')
		 const text = section.querySelector('.text')
		 
		 gsap.set(figure, {
		 width: 4 * section.clientHeight / 3
		 })
		 
		 const offset = figure.clientWidth - ((window.innerWidth - container.clientWidth) / 2) + 60
		 
		 gsap.set(text, {
		 marginLeft: section.dataset.Align === 'right' ? 0 : offset
		 })*/
	})
}

function getOffset (el)
{
	let xPos = 0
	let yPos = 0
	
	while (el)
	{
		if (el.tagName === 'body')
		{
			const xScroll = el.scrollLeft || document.documentElement.scrollLeft
			const yScroll = el.scrollTop || document.documentElement.scrollTop
			
			xPos += (el.offsetLeft - xScroll + el.clientLeft)
			yPos += (el.offsetTop - yScroll + el.clientTop)
		}
		else
		{
			xPos += (el.offsetLeft - el.scrollLeft + el.clientLeft)
			yPos += (el.offsetTop - el.scrollTop + el.clientTop)
		}
		
		el = el.offsetParent
	}
	return {
		x: xPos,
		y: yPos
	}
}

function initMasonry ()
{
	const masonry = Macy({
		container: 'section[data-photos] .photos',
		trueOrder: false,
		waitForImages: false,
		margin: 10,
		columns: 3,
		breakAt: {
			1200: 2,
			600: 1
		}
	})
}


